export default __webpack_public_path__ + "static/media/globe.3e15fdc2.gif";